<template>
  <router-view></router-view>
</template>

<script>
  export default {
    components: {},
    name: 'App'
  }
</script>



// WEBPACK FOOTER //
// App.vue?44c984a9